module.exports = __webpack_public_path__ + "static/media/aws_logo.946b35ec.png";